enum FontSize {
  Small = 'small',
  Middle = 'middle',
  Large = 'large',
}

export default FontSize;
